import React, { useState } from 'react';
import { FadeIn } from '../FadeIn';
import { ChevronDown } from 'lucide-react';
export function FAQAHA() {
  const faqs = [{
    q: 'Cât durează să parcurg tot cursul?',
    a: 'Poți parcurge un modul pe zi și termini în 5 zile. Sau poți lua un modul la 2 zile și termini în 10 zile. Fiecare modul durează în jur de 20 de minute. Ritmul tău este întotdeauna varianta corectă, nu există o viteză „corectă”.'
  }, {
    q: 'Acest curs înlocuiește terapia?',
    a: 'Nu. Acest curs este un început, nu un înlocuitor. Dacă simți că ai nevoie de sprijin specializat, te încurajez să cauți un terapeut. Tehnicile de aici funcționează excelent ca supliment între ședințe sau ca primul pas, înainte să ajungi la terapie.'
  }, {
    q: 'Cum funcționează exact? Primesc acces pe email?',
    a: 'După plată primești imediat pe email linkul către platforma privată, unde ai toate cele 5 audio-uri și workbook-ul PDF. Descarci PDF-ul, asculți audio-urile pe telefon sau laptop, lucrezi în ritmul tău. Acces pe viață.'
  }, {
    q: 'Ce se întâmplă dacă apar emoții pe care nu știu să le gestionez în timpul exercițiilor?',
    a: 'În timpul exercițiilor pot apărea emoții neașteptate, inclusiv tristețe sau lacrimi. Este normal și este un semn că ceva se mișcă. Dacă simți că un exercițiu este prea intens, oprește-te, respiră și revii când ești gata. Nu există termen limită.'
  }, {
    q: 'Pot să mă întorc la audio-uri după ce termin cursul?',
    a: 'Da. Ai acces pe viață la toate materialele. Multe participante se întorc la audio-ul de „Respirație de ancorare” sau la fișa „Kitul de urgență” de fiecare dată când apare un moment greu. De asta a fost conceput cursul, să îl ai la îndemână mereu.'
  }, {
    q: 'Ce este Grupul Cicatricilor și cum intru?',
    a: 'Este comunitatea privată a participantelor la Anima Healing Academy. Un spațiu cald, fără judecată, unde femei care trec prin experiențe similare se susțin. Primești linkul de acces pe email, împreună cu materialele cursului.'
  }, {
    q: 'Există garanție?',
    a: '[LIPSĂ — de stabilit cu clienta politica de rambursare. Recomandare echipă: garanție de 7 zile de satisfacție pentru low ticket, sau „fără întrebări” dacă materialul nu a fost descărcat/accesat]'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 md:py-28 bg-ivory overflow-hidden" data-id="element-95">
      <div className="max-w-[900px] mx-auto px-6 md:px-8" data-id="element-96">
        <div className="text-center mb-16" data-id="element-97">
          <FadeIn data-id="element-98">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium text-forest mb-6" data-id="element-99">
              Întrebări frecvente
            </h2>
          </FadeIn>
        </div>

        <div className="space-y-4" data-id="element-100">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.05} data-id="element-101">
              <div className={`border rounded-[20px] overflow-hidden transition-colors duration-300 ${openIndex === index ? 'bg-white border-gold/40 shadow-md' : 'bg-white/50 border-gold/20 hover:border-gold/40'}`} data-id="element-102">
                <button className="w-full text-left px-6 py-5 md:px-8 md:py-6 flex items-center justify-between gap-4 focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-103">
                  <span className="text-[19px] font-medium text-forest pr-8" data-id="element-104">
                    {faq.q}
                  </span>
                  <div className={`w-8 h-8 rounded-full bg-gold/10 flex items-center justify-center shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180 bg-gold/20' : ''}`} data-id="element-105">
                    <ChevronDown className="w-5 h-5 text-forest" data-id="element-106" />
                  </div>
                </button>

                <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-107">
                  <div className="px-6 pb-6 md:px-8 md:pb-8 pt-0 text-[18px] text-charcoal/70 leading-relaxed border-t border-gold/10 mt-2" data-id="element-108">
                    {faq.a}
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}